// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_it","controls":"_iu","controls__change":"_iv","controls__remove":"_iw","remove_text":"_ix","remove_btn":"_iy","remove_cancel":"_iz"};